export default function initSearch() {

    const trigger = "#navbar-menu-search, #mobile-navbar-menu-search",
        $document = $(document),
        $searchBar = $(".search-bar"),
        $searchBarPlaceholder = $(".search-bar__placeholder"),
        searchBarClass = "search-bar",
        activeSearchBarClass = searchBarClass + "--search",
        $input = $searchBar.find("input");

    const searchKeyUpEscape = function(e) {
        if (e.keyCode === 27) {
            $(".search-bar").removeClass("search-bar--search");
            $("#navbar-menu-search").removeClass("menu__list__item__link--active");
        }
    }

    $(trigger).click(function () {
        const activeButtonClass = $(this).hasClass("mobile-search") ?  "mobile-search--active" : "menu__list__item__link--active";

        if ($searchBar.hasClass(activeSearchBarClass)) {
            $input.blur();
            $document.unbind('keyup.outsideSearch', searchKeyUpEscape);
        } else {
            $input.focus();
            $document.bind('keyup.outsideSearch', searchKeyUpEscape);
        }

        $searchBar.toggleClass(activeSearchBarClass);
        $(this).toggleClass(activeButtonClass);

        return false;
    });

    $searchBarPlaceholder.click(function () {
        $input.focus();
    });

}



// WEBPACK FOOTER //
// ./js/navbar/commons/NavbarSearch.js